/**
 * Finds the underwriting result for a quote by fuzzy-matching the product name.
 * Handles trademark symbols and version suffixes in product names.
 *
 * @param productName - The product name to match
 * @param underwritingResults - Map of product names to underwriting results
 * @param isJointPolicy - Whether this is a joint/couples policy
 * @returns The matching underwriting result, or undefined if not found
 */
export function getUnderwritingResultForProduct(
  productName: string,
  underwritingResults: Record<string, UnderwritingResult> | undefined,
  isJointPolicy: boolean = false,
): UnderwritingResult | undefined {
  if (!underwritingResults || !productName) return undefined;

  // Normalize the product name: lowercase, remove trademarks, trim
  const normalizedQuoteName = productName.toLowerCase().replace(/[®™©]/g, '').trim();

  // Try to find a matching key in the results
  for (const [key, result] of Object.entries(underwritingResults)) {
    const normalizedKey = key.toLowerCase().replace(/[®™©]/g, '').trim();

    const productNamesMatch =
      normalizedQuoteName.includes(normalizedKey) || normalizedKey.includes(normalizedQuoteName);

    // Check if the joint status matches
    const keyIsJoint = normalizedKey.includes('joint');
    const jointStatusMatches = isJointPolicy === keyIsJoint;

    if (productNamesMatch && jointStatusMatches) {
      return result;
    }
  }

  return undefined;
}